module.exports = __webpack_public_path__ + "img/img-vectors-thankyou.5272e910.png";